import request from './fetch';

// login
export function login (data) {
  return request({
    url: '/v1/auth/login',
    method: 'post',
    data
  });
}

export const getFilterMenu = () => {
    return request({
      url: '/v1/pain-point/filterMenu',
      method: 'get',
    });
  }


// brand-performance-category-performance
export const painPointGetList = (data) => {
  return request({
    url: '/v1/pain-point/list',
    method: 'post',
    data: data
    // data: {typeIndex:2,index:1}
  });

// For test
  let returnData = []
  for (let key in testdata) {
    returnData.push({
      id: key,
      needTitle: testdata[key].title,
      needDes: testdata[key].des,
      Q9_3_Q10_2:Math.ceil(Math.random()*100),
      Q9_4_Q10_3:Math.ceil(Math.random()*100),
      z:Math.ceil(Math.random()*50)
      // ...testdata[key]
    })
  }
  return {data:returnData};
};

// brand-performance-category-performance
export const painPointGetDetail = (params) => {
    return request({
      url: '/v1/pain-point/detail',
      method: 'post',
      data: params
    });
};

export const painPointGetVerbatims = (params) => {
    return request({
      url: '/v1/pain-point/verbatims',
      method: 'post',
      data: params
    });
};

